module.exports = __webpack_public_path__ + "img/dd_green.041d21e0.svg";